import { useIsClient } from '../hooks/is-client';

const ClientOnly = ({ children }) => {
  const isClient = useIsClient();

  return isClient ? children : null;
};

export default ClientOnly;
